import { Center, Loader } from '@mantine/core';

export default function GeneratingIndicator() {
  return (
    <Center
      w={20}
      h={20}
      bg="brand.0"
      style={{ borderRadius: '50%' }}
      data-testid="generating-indicator"
    >
      <Loader size={16} color="brand.6" />
    </Center>
  );
}
